<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                       
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Suas informações</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-9 col-lg-7 col-md-9">
                                                <div class="row">

                                                    <div class="col-xl-6">
                                                        <div class="submit-field">
                                                            <h5>Nome completo</h5>
                                                            <input type="text" class="with-border" placeholder="Informe seu nome completo..." v-model="form.nome">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-6">
                                                        <div class="submit-field">
                                                            <h5>E-mail</h5>
                                                            <input type="email" class="with-border" placeholder="Informe seu e-mail aqui" v-model="form.email">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-8">
                                                        <div class="submit-field">
                                                            <h5>Telefone</h5>
                                                            <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                        </div>
                                                    </div>
                                                        
                                                    <div class="col-lg-12 clearfix"></div>

                                                    <div class="col-xl-10 col-xs-12">
                                                        <div class="submit-field">
                                                            <h5>Mensagem</h5>
                                                            <textarea class="with-border" name="mensagem" cols="40" rows="5" id="mensagem" placeholder="Mensagem" spellcheck="true" required="required" v-model="form.mensagem"></textarea>
                                                            
                                                        </div>
                                                    </div>

                                                    <!-- Button -->
                                                    <div class="col-xl-12 margin-bottom-20">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">check_circle</i>
                                                            Enviar mensagem
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'Conta',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "telefone":         self.$root.user.telefone
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.post("api/contato.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response)
                loading.hide();
                alert(response.data.message);
                self.$router.push({"name": "Dashboard"});
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    mounted: function() {
        loading.hide();
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Contato.vue